import { useQuery } from 'data-fetching-client';
import { isCountryCodeString } from 'pricing-pages-api/currency/types';
import { GET_PUBLIC_PRODUCTS_V2_QUERY } from '../../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.dfc.new';
import { getCountryCode } from 'pricing-pages-ui-components/utils/localeUtils';
import { KNOWN_PRODUCT_API_NAMES } from '../constants/allProductApiNames';
export const ProductCacheWarmer = () => {
  const rawCountryCode = getCountryCode();
  const countryCode = isCountryCodeString(rawCountryCode) ? rawCountryCode : undefined;
  useQuery(GET_PUBLIC_PRODUCTS_V2_QUERY, {
    variables: {
      productApiNames: KNOWN_PRODUCT_API_NAMES,
      countryCode
    }
  });
  return null;
};